import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If a user logs out on your frontend, you should call `}<inlineCode parentName="p">{`reset`}</inlineCode>{` to unlink any future events made on that device with that user. `}</p>
    <p>{`This is important if your users are sharing a computer, as otherwise all of those users are grouped together into a single user due to shared cookies between sessions. `}<strong parentName="p">{`We strongly recommend you call `}<inlineCode parentName="strong">{`reset`}</inlineCode>{` on logout even if you don't expect users to share a computer.`}</strong></p>
    <p>{`You can do that like so:`}</p>
    <MultiLanguage selector="tabs" mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.reset()
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ios"
        }}>{`posthog.reset()
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-android_kotlin"
        }}>{`PostHog.reset()
`}</code></pre>
    </MultiLanguage>
    <p>{`If you `}<em parentName="p">{`also`}</em>{` want to reset the `}<inlineCode parentName="p">{`device_id`}</inlineCode>{` so that the device will be considered a new device in future events, you can pass `}<inlineCode parentName="p">{`true`}</inlineCode>{` as an argument:`}</p>
    <MultiLanguage selector="tabs" mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.reset(true)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ios"
        }}>{`posthog.reset(true)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-android_kotlin"
        }}>{`PostHog.reset()
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      